import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Mail, CheckCircle } from 'lucide-react';

const SignupSuccess = () => {
  const location = useLocation();
  const email = location.state?.email || 'your email';

  return (
    <div className="flex-1 flex items-center justify-center p-4 bg-gradient-to-br from-slate-50 to-slate-100">
      <Card className="w-full max-w-2xl">
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
              <div className="relative">
                <Mail className="h-20 w-20 text-cyan-600" />
                <CheckCircle className="h-8 w-8 text-green-600 absolute -bottom-1 -right-1 bg-white rounded-full" />
              </div>
            </div>
            <CardTitle className="text-3xl mb-2">Check Your Email</CardTitle>
            <p className="text-slate-600 text-lg">
              We've sent a verification link to <strong>{email}</strong>
            </p>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="bg-cyan-50 border border-cyan-200 rounded-lg p-4 space-y-3">
              <h3 className="font-semibold text-cyan-900 flex items-center gap-2">
                <CheckCircle className="h-5 w-5" />
                Next Steps:
              </h3>
              <ol className="list-decimal list-inside space-y-2 text-sm text-cyan-800">
                <li>Open your email inbox</li>
                <li>Look for an email from Keyless PMS</li>
                <li>Click the verification link in the email</li>
                <li>You'll be redirected to log in to your account</li>
              </ol>
            </div>

            <div className="text-center space-y-4">
              <p className="text-sm text-slate-500">
                Didn't receive the email? Check your spam folder or request a new verification link at login.
              </p>
              
              <div className="flex gap-3">
                <Link to="/login" className="flex-1">
                  <Button variant="outline" className="w-full">
                    Go to Login
                  </Button>
                </Link>
                <Link to="/" className="flex-1">
                  <Button className="w-full bg-gradient-to-r from-cyan-600 to-blue-600 hover:from-cyan-700 hover:to-blue-700">
                    Back to Home
                  </Button>
                </Link>
              </div>
            </div>

            <div className="border-t pt-4 text-center">
              <p className="text-xs text-slate-500">
                The verification link will expire in 24 hours.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
  );
};

export default SignupSuccess;
